/**
 * CSS custom property references for dynamic UI bindings in TypeScript/HTML.
 * Values are var() references — not hex — so runtime theme changes propagate.
 * Part of AppTheme (see app-theme.ts) alongside logo branding.
 */
export const ThemeTokens = {
  primary: 'var(--saferoads-primary)',
  primaryDark: 'var(--saferoads-primary-dark)',
  primaryMid: 'var(--saferoads-primary-mid)',
  secondary: 'var(--saferoads-secondary)',
  accent: 'var(--saferoads-accent)',
  accentGold: 'var(--saferoads-accent-gold)',
  accentBlue: 'var(--saferoads-accent-blue)',
  light: 'var(--saferoads-light)',
  dark: 'var(--saferoads-dark)',
  darkSlate: 'var(--saferoads-dark-slate)',
  background: 'var(--saferoads-background)',
  surface: 'var(--saferoads-surface)',
  text: 'var(--saferoads-text)',
  textPrimary: 'var(--saferoads-text-primary)',
  textBody: 'var(--saferoads-text-body)',
  textSecondary: 'var(--saferoads-text-secondary)',
  textMuted: 'var(--saferoads-text-muted)',
  textInverse: 'var(--saferoads-text-inverse)',
  textGray: 'var(--saferoads-text-gray)',
  border: 'var(--saferoads-border)',
  success: 'var(--saferoads-success)',
  successAlt: 'var(--saferoads-success-alt)',
  fixedAmount: 'var(--saferoads-fixed-amount)',
  fixedSuccess: 'var(--saferoads-fixed-success)',
  warning: 'var(--saferoads-warning)',
  warningDark: 'var(--saferoads-warning-dark)',
  error: 'var(--saferoads-error)',
  errorBright: 'var(--saferoads-error-bright)',
  info: 'var(--saferoads-info)',
  neutral400: 'var(--saferoads-neutral-400)',
  neutral500: 'var(--saferoads-neutral-500)',
  grayDisabled: 'var(--saferoads-gray-disabled)',
} as const;
